import { format } from "date-fns";
import { ROUTES, callAPI } from "../API/index";
import axios from "axios";

// Utils
const renameKeys = function (obj, keyMap) {
    /**
    *  dict -> dict 에서 dict key 이름을 변경하는 utils
    */
    let newObj = {};
    Object.keys(obj).forEach(oldKey => {
        if (keyMap[oldKey]) {
            // keyMap[oldKey]가 배열이면 여러 개의 키로 할당
            if (Array.isArray(keyMap[oldKey])) {
                keyMap[oldKey].forEach(newKey => {
                    newObj[newKey] = obj[oldKey];
                });
            } else {
                // 단일 키로 할당
                newObj[keyMap[oldKey]] = obj[oldKey];
            }
        } else {
            // 맵핑되지 않은 키도 포함시키고 싶다면 이 부분에서 추가
            newObj[oldKey] = obj[oldKey];
        }
    });
    return newObj;
};

// -----------------------------------------------
// Common
// -----------------------------------------------
export const loginService = (data) => {
    /**
     * 로그인
     */
    return callAPI(ROUTES.USER.LOGIN, 'POST', data);
}

export const logoutService = (refreshToken, token) => {
    /**
     * 로그아웃
     */
    return callAPI(ROUTES.USER.LOGOUT, 'POST', { refresh: refreshToken });
}

export const refreshTokenService = (refreshToken, token) => {
    /**
     * 토큰 갱신
     */
    return callAPI(ROUTES.USER.TOKEN.REFRESH, 'POST', { refresh: refreshToken });
}

export const getUserInfoByAccessToken = async (accessToken) => {
    /**
     * Access 토큰으로 사용자 정보 조회
     */
    try {
        const url = `/token/refresh/`;
        const response = await axios.get(url, {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            withCredentials: true
        });
        return response.data;
    } catch (error) {
        return Promise.reject(error.response?.data || error.message || '사용자 정보 조회 실패');
    }
}

export const changePasswordService = (data) => {
    /**
     * 비밀번호 변경
     */
    return callAPI(ROUTES.USER.PASSWORD.CHANGE, 'POST', data);
}

export const fetchCodeList = (code_list) => {
    /**
     * 코드 목록 반환
     */
    return callAPI(ROUTES.COMMON.CODE, 'GET', {}, { code_list });
}

export const fetchEmployeeSalaryList = (employeeNo, paymentType) => {
    /**
     * 사원 급여 목록 반환
     */
    return callAPI(ROUTES.COMMON.EMPLOYEE_SALARY, 'GET', {}, { employeeNo, paymentType });
}

export const fetchEmployeeWorkTimeFormat = (employeeNo, workYM, paymentType, isRemaining = false) => {
    /**
     * 사원 근무 시간 포맷 목록 반환
     * isRemaining: 잔여 연차 조회 여부 (기본값: false)
     */

    if (paymentType === "0001" || paymentType === undefined) {
        if (workYM === undefined) {
            workYM = format(new Date(), "yyyy-MM");
        }
        return callAPI(ROUTES.COMMON.WORK_TIME_FORMAT, 'GET', {}, { 
            employeeNo, 
            workYM, 
            isRemaining 
        });
    } else {
        return []
    }
}

export const fetchEmployeeWorkTimeFormatList = (workYM) => {
    /**
     * 사원 근무 시간 포맷 목록 반환
     */
    if (workYM === undefined) {
        workYM = format(new Date(), "yyyy-MM");
        return callAPI(ROUTES.COMMON.WORK_TIME_FORMAT_LIST, 'GET', {}, { workYM });
    } else {
        return callAPI(ROUTES.COMMON.WORK_TIME_FORMAT_LIST, 'GET', {}, { workYM });
    }
}

export const fetchCrtlwhTime = (startTime, endTime, atendNos) => {
    /**
     * 근무시간 조회
     */
    if (startTime && endTime) {
        const startTimeFormat = format(startTime, 'HH:mm');
        const endTimeFormat = format(endTime, 'HH:mm');

        const query = {
            startTime: startTimeFormat,
            endTime: endTimeFormat
        };

        // 선택한 휴식시간 no 배열이 있는 경우 함께 전송
        if (Array.isArray(atendNos) && atendNos.length > 0) {
            query.atendNos = atendNos;
        }

        return callAPI(ROUTES.COMMON.CRTLWH_TIME, 'GET', {}, query);
    } else {
        return Promise.reject(new Error('startTime 또는 endTime이 없습니다.'))
    }
}

export { renameKeys };

export const fetchWorkdays = (startDate, endDate, companyNo, employeeNo) => {
    /**
     * 근무일 조회
                startDate: YYYY-MM-DD
                endDate: YYYY-MM-DD
                companyNo: (선택) SuperAdmin만 임의 지정 가능. 없으면 본인 회사
                employeeNo: (선택) 권한 검증용. User는 본인 번호만 허용
     */
    if (startDate && endDate) {
        const startDateFormat = format(startDate, 'yyyy-MM-dd')
        const endDateFormat = format(endDate, 'yyyy-MM-dd')

        return callAPI(ROUTES.COMMON.WORKDAYS, 'GET', {}, {
            startDate: startDateFormat,
            endDate: endDateFormat,
            companyNo,
            employeeNo
        });
    } else {
        return Promise.reject(new Error('startDate 또는 endDate가 없습니다.'))
    }
}
